export function sanitizeMobileInput(raw) {
  if (raw === null || raw === undefined) return '';

  const trimmed = String(raw).trim();
  const compacted = trimmed.replace(/\s+/g, '');
  const filtered = compacted.replace(/[^\d+]/g, '');

  if (!filtered) return '';

  const plusIndex = filtered.indexOf('+');
  if (plusIndex > 0) {
    return filtered.replace(/\+/g, '');
  }

  return filtered.startsWith('+') ? `+${filtered.slice(1).replace(/\+/g, '')}` : filtered;
}

export function isValidMobile(raw) {
  if (raw === null || raw === undefined) return false;

  const normalized = String(raw).trim().replace(/\s+/g, '');
  if (!normalized) return false;
  if (normalized.length > 15) return false;
  if (!/^\+?\d+$/.test(normalized)) return false;

  return true;
}
